import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { JSONRPCErrorCode } from 'json-rpc-2.0';
import { emitter } from '../events/bridge-events-emitter';
import { rpcError, rpcSuccess } from './bridge-api-rpc-message';

/* eslint-disable no-console */

/**
 * Maintains all handlers for commands passed into the bridge API.
 *
 * I.e., if JS context 1 invokes a command which JS context 2 is meant to handle, {@link RequestHandler}
 * is responsible for connecting the {@link RPCRequest} to the appropriate command handler in JS context 2. It
 * will also communicate the result of the request over the provided {@link transport} protocol.
 */
export var RequestHandler = /*#__PURE__*/function () {
  function RequestHandler(transport) {
    _classCallCheck(this, RequestHandler);
    /**
     * A mapping from clientId:commandName -> handlers for those commands.
     *
     * @description We enforce only 1 handler per clientId+command pair, so that callees can listen for responses to a command.
     * This allows multiple clients to register handlers for the same command type.
     */
    _defineProperty(this, "handlers", new Map());
    this.transport = transport;
  }

  /**
   * Register a handler for a specific command type for a specific client.
   *
   * @description When a command of type {@link CommandClass} is received, the handler will be invoked in a 1-1 manner.
   * This is to ensure the result of the command invocation can be cleanly passed to the callee.
   *
   * @param clientId The client identifier that this handler is registered for
   * @param CommandClass The command class to register a handler for
   * @param handler The handler function to invoke when the command is received
   * @returns void
   */
  return _createClass(RequestHandler, [{
    key: "register",
    value: function register(clientId, CommandClass, handler) {
      var handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
      this.handlers.set(handlerKey, handler);
    }

    /**
     * Unregisters a handler for a specific command type for a specific client.
     */
  }, {
    key: "unregister",
    value: function unregister(clientId, CommandClass) {
      var handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
      this.handlers.delete(handlerKey);
    }

    /**
     * Unregisters all handlers for a specific client.
     *
     * @param clientId The client identifier to remove all handlers for
     * @returns number of handlers removed
     */
  }, {
    key: "unregisterAll",
    value: function unregisterAll(clientId) {
      var keysToDelete = [];
      var prefix = "".concat(clientId, ":");

      // find all relevant keys
      var _iterator = _createForOfIteratorHelper(this.handlers.keys()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _key = _step.value;
          if (_key.startsWith(prefix)) {
            keysToDelete.push(_key);
          }
        }

        // drop them
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _i = 0, _keysToDelete = keysToDelete; _i < _keysToDelete.length; _i++) {
        var key = _keysToDelete[_i];
        this.handlers.delete(key);
      }
      return keysToDelete.length;
    }

    /**
     * Invokes the appropriate handler for a given {@link RPCRequest}, and yields the result via
     * {@link transport} to the appropriate JavaScript context. If the handler throws, propagates an
     * {@link RPCResponse} with an error body. Vice versa for a successful handler response.
     *
     * @param request incoming RPC request (delegated method call, as a command)
     */
  }, {
    key: "handleRequest",
    value: (function () {
      var _handleRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var params, handlerKey, handler, err, startTime, result, duration, _err, _duration;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = request.params;
              handlerKey = this.createHandlerKey(params.receiverId, request.method);
              handler = this.handlers.get(handlerKey);
              emitter().emit({
                type: 'command-received',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                properties: _objectSpread({}, params),
                groupId: params.groupId
              });
              if (handler) {
                _context.next = 10;
                break;
              }
              err = "handler not found for ".concat(request.method, " with clientId ").concat(params.receiverId);
              console.warn(err);

              // emit command failed event
              emitter().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                  message: err,
                  code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
              });

              // communicate to sender that handler failed
              this.transport.send(rpcError(request.id, params.receiverId, params.senderId, JSONRPCErrorCode.MethodNotFound, new Error(err)));
              return _context.abrupt("return");
            case 10:
              startTime = performance.now();
              _context.prev = 11;
              _context.next = 14;
              return handler(request.params);
            case 14:
              result = _context.sent;
              duration = performance.now() - startTime; // emit command completed event
              emitter().emit({
                type: 'command-completed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
              });
              this.transport.send(rpcSuccess(request.id, params.receiverId, params.senderId, result));
              _context.next = 27;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](11);
              _err = _context.t0 instanceof Error ? _context.t0 : new Error(String(_context.t0));
              _duration = performance.now() - startTime; // emit command failed event
              emitter().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                  message: _err.message,
                  code: 'HANDLER_ERROR',
                  stack: _err.stack
                },
                duration: _duration,
                groupId: params.groupId
              });
              this.transport.send(rpcError(request.id, params.receiverId, params.senderId, JSONRPCErrorCode.InternalError, _err));
              console.error(_err);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[11, 20]]);
      }));
      function handleRequest(_x) {
        return _handleRequest.apply(this, arguments);
      }
      return handleRequest;
    }()
    /**
     * Directly invoke a handler of a specific command for a specific client.
     */
    )
  }, {
    key: "invoke",
    value: (function () {
      var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(command, params) {
        var _params$_invocationId;
        var handlerKey, handler, _params$_invocationId2, err, startTime, result, duration, _err2, _duration2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              handlerKey = this.createHandlerKey(params.receiverId, command.identifier);
              handler = this.handlers.get(handlerKey);
              emitter().emit({
                type: 'command-received',
                commandId: (_params$_invocationId = params._invocationId) !== null && _params$_invocationId !== void 0 ? _params$_invocationId : 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                properties: params,
                groupId: params.groupId
              });
              if (handler) {
                _context2.next = 8;
                break;
              }
              err = "handler not found for command ".concat(command.identifier, " with clientId ").concat(params.receiverId);
              console.error(err);

              // emit command failed event
              emitter().emit({
                type: 'command-failed',
                commandId: (_params$_invocationId2 = params._invocationId) !== null && _params$_invocationId2 !== void 0 ? _params$_invocationId2 : 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                  message: err,
                  code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
              });
              return _context2.abrupt("return", undefined);
            case 8:
              startTime = performance.now();
              _context2.prev = 9;
              result = handler === null || handler === void 0 ? void 0 : handler(params);
              duration = performance.now() - startTime; // emit command completed event
              emitter().emit({
                type: 'command-completed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
              });
              return _context2.abrupt("return", result);
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](9);
              _err2 = _context2.t0 instanceof Error ? _context2.t0 : new Error(String(_context2.t0));
              _duration2 = performance.now() - startTime; // emit command failed event
              emitter().emit({
                type: 'command-failed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                  message: _err2.message,
                  code: 'HANDLER_ERROR',
                  stack: _err2.stack
                },
                duration: _duration2,
                groupId: params.groupId
              });
              throw _err2;
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 16]]);
      }));
      function invoke(_x2, _x3) {
        return _invoke.apply(this, arguments);
      }
      return invoke;
    }()
    /**
     * Clear all relevant state for handling of responses.
     */
    )
  }, {
    key: "destroy",
    value: function destroy() {
      this.handlers.clear();
    }

    /**
     * Creates a unique key for the handler mapping using clientId and command name.
     */
  }, {
    key: "createHandlerKey",
    value: function createHandlerKey(clientId, commandName) {
      return "".concat(clientId, ":").concat(commandName);
    }
  }]);
}();